import { render, staticRenderFns } from "./PricingTableMobile.vue?vue&type=template&id=c7b90346&scoped=true&"
import script from "./PricingTableMobile.vue?vue&type=script&lang=js&"
export * from "./PricingTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableMobile.vue?vue&type=style&index=0&id=c7b90346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b90346",
  null
  
)

export default component.exports